import React, { useEffect } from 'react';
import ImplantSection from '../components/ImplantSection';
import { useLanguage } from '../contexts/LanguageContext';
import CtaSection from '../components/CtaSection';

const ImplantsPage: React.FC = () => {
  const { language, translations } = useLanguage();

  useEffect(() => {
    // Set dynamic page title based on language
    let pageTitle = 'Implantate - SeaDent Mallorca';
    if (language === 'en') {
      pageTitle = 'Dental Implants - SeaDent Mallorca';
    } else if (language === 'es') {
      pageTitle = 'Implantes Dentales - SeaDent Mallorca';
    } else if (language === 'ru') {
      pageTitle = 'Зубные Имплантаты - SeaDent Майорка';
    }

    document.title = pageTitle;

    // Set meta description based on language
    let metaContent = 'Moderne Zahnimplantate für ein natürliches Lächeln und mehr Lebensqualität. Hochwertige Materialien und schmerzfreie Behandlung bei SeaDent Mallorca.';
    if (language === 'en') {
      metaContent = 'Modern dental implants for a natural smile and improved quality of life. High-quality materials and pain-free treatment at SeaDent Mallorca.';
    } else if (language === 'es') {
      metaContent = 'Implantes dentales modernos para una sonrisa natural y mejor calidad de vida. Materiales de alta calidad y tratamiento sin dolor en SeaDent Mallorca.';
    } else if (language === 'ru') {
      metaContent = 'Современные зубные имплантаты для естественной улыбки и улучшения качества жизни. Высококачественные материалы и безболезненное лечение в SeaDent Майорка.';
    }

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', metaContent);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = metaContent;
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, [language]);

  return (
    <main className="pt-20 lg:pt-32">
      <div className="bg-navy text-white py-20">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">{translations.implants.title}</h1>
          <p className="text-xl">{translations.implants.intro.split('.')[0]}.</p>
        </div>
      </div>
      <ImplantSection />
      <CtaSection />
    </main>
  );
};

export default ImplantsPage; 